<template>
  <div :class="'qc-account-login qc-light-light-' + hightLightFormItem" v-show="props.show">
    <div :class="'qc-form-item ' + (showAccountSelect ? 'selected-box' : '')">
      <div class="qc-form-item-label">
        <div class="qc-sprites qc-sprites-phone_icon"></div>
      </div>
      <div class="qc-form-input">
        <input type="text"
          placeholder="请输入青瓷账号"
          name="account"
          style="width: 100%;"
          v-model.trim="account"
          autocomplete="off"
          @input="handleAccountInput"
          @focus="() => onFocus(1)"
          @blur="onBlur" />
      </div>
      <div v-if="accountList.length" class="qc-form-operation" @click="toggleAccountSelect()">
        <div class="qc-sprites qc-sprites-more_icon"></div>
      </div>
      <div class="qc-select-box qc-channel-select-box">
        <div class="qc-select-mask" @click="toggleAccountSelect()"></div>
        <div class="qc-select-line"></div>
        <ul>
          <li v-for="(item, idx) in accountList" :key="idx" class="qc-select-options-item" @click="selectAccount(item)">
            <span>{{ item.account }}</span>
            <b class="qc-options-delete" @click.stop="removeAccountItem(item.account)"></b>
          </li>
        </ul>
      </div>
    </div>
    <div class="qc-form-item">
      <div class="qc-form-item-label">
        <div class="qc-sprites qc-sprites-password_icon"></div>
      </div>
      <div class="qc-form-input">
        <input :type="showPassword ? 'text' : 'password'"
          placeholder="请输入密码"
          name="password"
          v-model.trim="password"
          autocomplete="off"
          @input="handlePasswordInput"
          @focus="() => onFocus(2)"
          @blur="onBlur" />
      </div>
      <div v-if="!isSelected" class="qc-form-operation" @click="togglePassword()">
        <div v-if="showPassword" class="qc-sprites qc-sprites-password_show_icon"></div>
        <div v-else class="qc-sprites qc-sprites-password_hide_icon"></div>
      </div>
    </div>
    <div :class="'qc-default-btn qc-confirm-btn ' + (isFormInvalid ? 'qc-disable-btn' : '')" @click="onLogin()">登录</div>

    <div class="qc-agreement-box">
      <div class="qc-agreement-left" @click="toggleAgreement()">
        <div v-if="isCheckedAgreement" class="qc-sprites qc-sprites-selected_icon"></div>
        <div v-else class="qc-sprites qc-sprites-not_select_icon"></div>
      </div>
      <div class="qc-agreement-right">
        <span @click="toggleAgreement()">阅读并同意</span><a 
          :href="AGREEMENT.SERVICE" target="_blank">{{ AGREEMENT.SERVICE_LABEL }}</a>、<a 
          :href="AGREEMENT.PRIVACY" target="_blank">{{ AGREEMENT.PRIVACY_LABEL }}</a>、<a 
          :href="AGREEMENT.CHILD_PRIVACY" target="_blank">{{ AGREEMENT.CHILD_PRIVACY_LABEL }}</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue';
import { Toast } from '../../subComponents/Toast/index';
import ApiManager from '../../core/api/index';
import { maskPhone } from '../../core/utils/index';
import { LOGIN_TYPE, AGREEMENT } from '../../core/constants/index';
import type { DomesticAccountProps, AccountItem } from '../types';

const props = withDefaults(defineProps<DomesticAccountProps>(), {});

const account = ref('');
const accountError = computed(() => {
  if (!account.value) {
    return '请输入账号';
  }
  if (!new RegExp('^\\+{0,1}[0-9]+$').test(account.value)) {
    return '请输入正确的账号';
  }
});

const password = ref('');
const passwordError = computed(() => {
  if (!password.value) {
    return '请输入密码';
  }
  if (!new RegExp('^[0-9A-Za-z_/+!@#:\\{\\}\\|%;\\^\\&\\*-]{6,20}$').test(password.value)) {
    return '密码格式不正确';
  }
});

const isSelected = ref(false);
const showAccountSelect = ref(false);
const showPassword = ref(false);
const toggleAccountSelect = () => {
  showAccountSelect.value = !showAccountSelect.value;
};
const togglePassword = () => {
  showPassword.value = !showPassword.value;
};

const isCheckedAgreement = ref(false);
const toggleAgreement = () => {
  isCheckedAgreement.value = !isCheckedAgreement.value;
};

const handleAccountInput = () => {
  if (isSelected.value) {
    password.value = '';
    isSelected.value = false;
  }
};
const handlePasswordInput = () => {
  if (isSelected.value) {
    isSelected.value = false;
    password.value = '';
  }
};

const isFormInvalid = computed(() => {
  return !!accountError.value || !!passwordError.value || !isCheckedAgreement.value;
});

const accountListStr = localStorage.getItem('QC_PLATFORM_UI_ACCOUNT_LIST');
const accountList = ref((accountListStr && props.autoDown) ? JSON.parse(accountListStr) : []);

// 过滤过期的账号
function filterInvalidAccount () {
  accountList.value = accountList.value.filter((acc: AccountItem) => acc.accessToken && acc.expireIn && acc.expireIn > Math.floor(Date.now() / 1000));
}
filterInvalidAccount();

const addAccountItem = (accountItem: AccountItem) => {
  if (!props.autoDown) { return; }
  const index = accountList.value.findIndex((acc: AccountItem) => acc.account === accountItem.account);
  if (index === -1) {
    accountList.value.unshift(accountItem);
    accountList.value.length > 5 && (accountList.value.length = 5);
  } else {
    accountList.value.splice(index, 1);
    accountList.value.unshift(accountItem);
  }
  localStorage.setItem('QC_PLATFORM_UI_ACCOUNT_LIST', JSON.stringify(accountList.value));
};

const removeAccountItem = (_account: string) => {
  const index = accountList.value.findIndex((item:AccountItem) => item.account === _account);
  if (index !== -1) {
    accountList.value.splice(index, 1);
  }
  if (accountList.value.length === 0) {
    showAccountSelect.value = false;
  }
  localStorage.setItem('QC_PLATFORM_UI_ACCOUNT_LIST', JSON.stringify(accountList.value));
};
const selectAccount = (accountItem: AccountItem) => {
  account.value = accountItem.account;
  showPassword.value = false;
  password.value = '1111111111111';
  isSelected.value = true;
  showAccountSelect.value = false;
};

const onLogin = async () => {
  if (accountError.value) {
    Toast(accountError.value);
    return;
  } else if (passwordError.value) {
    Toast(passwordError.value);
    return;
  } else if (!isCheckedAgreement.value) {
    props.openWarmTip();
    return;
  }
  if (isSelected.value) {
    const idx = accountList.value.findIndex((item: AccountItem) => item.account === account.value);
    const accountItem = accountList.value[idx];
    // 取消校验时间戳，改成请求接口去验证token有效性
    const isValid = await ApiManager.getInstance().user.checkToken(accountItem.accessToken);
    if (isValid) {
      props.onFinish(accountItem.accessToken, { loginWay: 'account', data: { account: maskPhone(accountItem.account) } });
      resetData();
    } else {
      Toast('账号已过期，请重新登录');
      resetData(false);
      removeAccountItem(accountItem.account);
    }
    return;
  }

  await ApiManager.getInstance().user.login({
    type: LOGIN_TYPE.ACCOUNT,
    account: account.value,
    password: password.value
  }).then((response) => {
    if (response.code === 200) {
      const { access_token, expires_in } = response.metadata;
      addAccountItem({ account: account.value, accessToken: access_token, expireIn: expires_in });
      props.onFinish(access_token, {
        loginWay: 'account',
        data: { account: maskPhone(account.value) }
      });
      resetData();
    } else {
      Toast(response.message);
    }
  });
};

// 高亮的表单行
const hightLightFormItem = ref(0);

// 表单聚焦
const onFocus = (rowIdx?: number) => {
  rowIdx && (hightLightFormItem.value = rowIdx);
};
const onBlur = () => {
  hightLightFormItem.value = 0;
};

function resetData (isClearAccount = true) {
  if (isClearAccount) { account.value = ''; }
  showAccountSelect.value = false;
  showPassword.value = false;
  password.value = '';
  isCheckedAgreement.value = false;
  isSelected.value = false;
  hightLightFormItem.value = 0;
}

watch(() => props.show, (newVal) => {
  if (!newVal) {
    props.onChangeAccountCache(account.value);
    resetData(false);
  }
});
watch(() => props.accountCache, (newVal) => {
  account.value = newVal;
});
watch(() => props.isAgreement, (newVal) => {
  isCheckedAgreement.value = newVal;
})
watch(() => showAccountSelect, (newVal) => {
  if (newVal) {
    filterInvalidAccount();
  }
})
</script>